import { create } from 'zustand';

import { EventsModalType } from '../enums/events-modal-type.const';

type OpenModalPayload = {
  metadata?: string;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  type: EventsModalType;
};

type EventsModalStoreState = {
  handleAccept: () => void;
  handleDismiss: () => void;
  metadata: null | string;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  open: boolean;
  openModal: (payload: OpenModalPayload) => void;
  type: EventsModalType;
};

const INITIAL_STATE: Omit<EventsModalStoreState, 'handleAccept' | 'handleDismiss' | 'openModal'> = {
  metadata: null,
  onAcceptCallback: undefined,
  onDismissCallback: undefined,
  open: false,
  type: EventsModalType.GET_MORE_ENVELOPES,
};

export const eventsModalStore = create<EventsModalStoreState>()((set, get) => ({
  ...INITIAL_STATE,

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    set(INITIAL_STATE);
    callback?.();
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    set(INITIAL_STATE);
    callback?.();
  },

  openModal: ({ type, metadata, onAcceptCallback, onDismissCallback }) => {
    set({
      metadata: metadata ?? null,
      onAcceptCallback,
      onDismissCallback,
      open: true,
      type,
    });
  },
}));
